//TODO: replace Loading... with LoadingIndicator component

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import promotionConfig from '../promotionConfig';

const Logout = ({ user, config, actions }) => {
    useEffect(() => {
        handleLogout();
    }, [config, user]);

    const handleLogout = async () => {
        const myHost = window.location.protocol + '//' + window.location.host;
        const logoutDestination = promotionConfig.getLogoutDestination(myHost, config?.config.logout_host_uri);

        await actions.userActions.logout();
        window.location.href = logoutDestination;
    };
    // Show loading state to avoid glitchy behavior of showing another screen that quickly switches to the loading page
    return (
        <React.Fragment key='loading-indicator-section'>
            <div className='d-flex justify-content-center bg-white'>
                <div className='loading-indicator' role='status'>
                    <span className='sr-only'>Loading...</span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
